<template>
  <div
    class="bg-white mt-4 first:mt-0 last:mb-4 pt-4 ml-6 sm:pl-0 sm:ml-12 border-t border-gray-200 flex flex-col gap-4"
    :class="{
      'opacity-80 select-none': disabled,
    }"
  >
    <div
      class="flex items-start gap-2 cursor-pointer"
      :class="{
        '!cursor-default': disabled,
      }"
      @click="() => (!disabled ? checkAll() : null)"
    >
      <input
        :indeterminate="hasChildrenChecked"
        :checked="groupChecked"
        type="checkbox"
        class="h-4 w-4 mt-0.5 rounded-xs border-gray-300 text-brand-900 focus:ring-0 focus:outline-0 focus:ring-offset-0 cursor-pointer enabled:hover:opacity-80"
        :class="{
          '!cursor-not-allowed': disabled,
        }"
        :disabled="disabled"
        @click.stop="checkAll"
      />
      <div class="flex flex-col gap-0 enabled:hover:opacity-80">
        <p class="text-sm font-medium m-0 text-gray-700">
          {{ t(`permissions.${permissionGroup.name}.title`) }}
        </p>
        <p class="text-xs font-lighter m-0 text-gray-600">
          {{ t(`permissions.${permissionGroup.name}.description`) }}
        </p>
      </div>
    </div>
    <div class="flex flex-col gap-4">
      <Permission
        v-for="permission in permissionGroup.permissions"
        :key="permission.id"
        :permission="permission"
        :checked="checked(permission.id)"
        :disabled="disabled"
        @change="handleUpdate"
      />
    </div>
  </div>
</template>

<script setup>
import Permission from "@/Tailwind/Components/Settings/Permissions/Permission.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  permissionGroup: {
    type: Object,
    required: true,
  },
  value: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["change"]);

const { t } = useI18n();

const handleUpdate = (permission) => {
  let selectedValues = props.value;

  if (props.value.includes(permission.id)) {
    selectedValues = selectedValues.filter((id) => id !== permission.id);
  } else {
    selectedValues = [...selectedValues, permission.id];
  }

  emit("change", selectedValues);
};

const checked = (id) => {
  return props.value.includes(id);
};

const checkAll = () => {
  if (groupChecked.value) {
    emit(
      "change",
      props.value.filter(
        (id) =>
          !props.permissionGroup.permissions
            .map((permission) => permission.id)
            .includes(id)
      )
    );
  } else {
    emit("change", [
      ...props.value,
      ...props.permissionGroup.permissions
        .map((permission) => permission.id)
        .filter((id) => !props.value.includes(id)),
    ]);
  }
};

const groupChecked = computed(() => {
  return props.permissionGroup.permissions.every((permission) =>
    props.value.includes(permission.id)
  );
});

const hasChildrenChecked = computed(() => {
  return (
    !groupChecked.value &&
    props.permissionGroup.permissions.some((permission) =>
      props.value.includes(permission.id)
    )
  );
});
</script>
